module.exports = __webpack_public_path__ + "static/media/41.229501e9.mp3";